import { Injectable, signal } from '@angular/core';
import { environment } from '../../environments/environment';
import { IAppState } from '../types/infrastructure/interfaces/IAppState';

@Injectable({
  providedIn: 'root'
})
export class AppSettings {

  public static appTitle = 'BAT | Budgetantragstool';
  public appVersion = environment.version;
  public static production = environment.production; 
  public static appState: IAppState = {} as IAppState;
  
  public testRole : string | null = null;
  private _baseUrl = environment.baseUrl;
  private _baseAPIUrl = environment.baseAPIUrl;

  // navigation/...
  navigationApiBase = this.baseAPIUrl + '/api/navigation';
  navigationProjekteApi = this.navigationApiBase + '/projekte'
  navigationBudgetantraegeApi = this.navigationApiBase + '/budgetantraege'

  // info/...
  infoApiBase = this.baseAPIUrl + '/api/info';
  userinfoApi = this.infoApiBase + '/user';
  loginApi = this.infoApiBase + '/login';
  verwaltungsbereicheApi = this.infoApiBase + '/verwaltungsbereiche'
  controllingbereicheApi = this.infoApiBase + '/controllingbereiche'
  plangebieteApi = this.infoApiBase + '/plangebiete'
  klassifizierungenApi = this.infoApiBase + '/klassifizierungen'
  quartiereApi = this.infoApiBase + '/quartiere'
  projektmanagerApi = this.infoApiBase + '/manager'
  projektsteuererApi = this.infoApiBase + '/steuerer'
  firmenApi = this.infoApiBase + '/firmen'

  // projekte/...
  infoTestApi = (testArt: string) => `${this.infoApiBase}/test/${testArt}`
  
  projekteApiBase = this.baseAPIUrl + '/api/projekte';
  projekteApi = (plangebiet: string, verwaltungsbereich: string, bearbeitung: string) => `${this.projekteApiBase}/${plangebiet}/bereich/${verwaltungsbereich}/bearbeitung/${bearbeitung}`;
  projekteAntragApi = this.projekteApiBase + '/antraege/neu'
  projekteInfoApi = (projektId: number) => `${this.projekteApiBase}/${projektId}/infos`
  projekteDetailsApi = (projektId: number) => `${this.projekteApiBase}/${projektId}`
  projekteDetailsAktivApi = (projektId: number) => `${this.projekteApiBase}/${projektId}/toggleAktiv`
  projekteDetailsKostengruppenAktuellApi = (projektId: number) => `${this.projekteApiBase}/${projektId}/kosten/aktuell`
  projekteDetailsKostengruppenPlanApi = (projektId: number) => `${this.projekteApiBase}/${projektId}/kosten/plan`
  projekteDetailsKostengruppenAbweichungApi = (projektId: number) => `${this.projekteApiBase}/${projektId}/kosten/abweichung`
  
  // budgetanträge/...
  budgetantraegeApiBase = this.baseAPIUrl + '/api/budgetantraege';
  budgetantraegeApi = (plangebiet: string, verwaltungsbereich: string) => `${this.budgetantraegeApiBase}/${plangebiet}/bereich/${verwaltungsbereich}`;
  budgetantraegeNeuApi = (projektId: number) => `${this.budgetantraegeApiBase}/neu/projekt/${projektId}`;
  budgetantraegeNeuLageplanApi = (projektId: number) => `${this.budgetantraegeApiBase}/neu/projekt/${projektId}/lageplan`;
  budgetantraegeViewmodelApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}`;
  
  budgetantraegeDetailsApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/details`;
  budgetantraegeDetailsLageplanApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/lageplan`;
  budgetantraegeKostenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/kosten`;
  
  budgetantraegeKostenherleitungenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/kostenherleitungen`;
  budgetantraegeKostenherleitungenTeilleistungeApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/kostenherleitungen/teilleistungen`;
  budgetantraegeKostenherleitungDetailApi = (baId: number, kostenherleitungId: number) => `${this.budgetantraegeApiBase}/${baId}/kostenherleitungen/${kostenherleitungId}`;
  budgetantraegeKostenherleitungenUpdateAuftragswerteApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/kostenherleitungen/updateauftragswerte`;
  
  budgetantraegeKostenherleitungDetailAnhangApi = (baId: number, kostenherleitungId: number) => `${this.budgetantraegeApiBase}/${baId}/kostenherleitungen/${kostenherleitungId}/anhang`;
  budgetantraegePreissteigerungApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/preissteigerung`;
  budgetantraegePreissteigerungKostenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/preissteigerung/kosten`;

  budgetantraegeRisikenChancenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/risikenchancen`;
  
  budgetantraegeFreigabeApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe`;
  budgetantraegeFreigabeAnhangApi = (baId: number, freigabestufe: string) => `${this.budgetantraegeApiBase}/${baId}/freigabe/${freigabestufe}/anhang/`;
  budgetantraegeFreigabeApplyApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe/apply`;
  budgetantraegeFreigabeRejectApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe/reject`;
  budgetantraegeFreigabeUrsachenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe/ursachen`;
  budgetantraegeFreigabeDetailsApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe/details`;
  budgetantraegeFreigabeAufhebenApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/freigabe/aufheben`;


  budgetantraegeVerlaufApi = (baId: number) => `${this.budgetantraegeApiBase}/${baId}/verlauf`;
  budgetantraegeReportApi= (budgetAntragID: number) => `${this.budgetantraegeApiBase}/${budgetAntragID}/report`;
  budgetantraegeReportGenerateApi= (budgetAntragID: number) => `${this.budgetantraegeApiBase}/${budgetAntragID}/generatereport`;
  
  // Wirtschaftspläne
  wirtschaftsplanApiBase = this.baseAPIUrl + '/api/wirtschaftsplan';
  wirtschaftsplanLoeschenApi = this.wirtschaftsplanApiBase + '/delete';
  
  constructor() {
  }

  get baseUrl(): string {
    if (this._baseUrl === null) {
      // Ermittlung der BaseUrl aus der Browser-Adressleiste
      let baseUrl = '';
      let urlHref = window.location.href;
      // console.log('BaseUrl (href): ' + urlHref);
      const baseUrlEndIndex = urlHref.lastIndexOf('/#');
      if (baseUrlEndIndex === -1) {
        if (urlHref.endsWith('/')) {
          baseUrl = urlHref.slice(0, urlHref.length - 1);
          // console.log('BaseUrl (trim): ' + baseUrl);
        } else {
          baseUrl = urlHref;
          // console.log('BaseUrl: ' + baseUrl);
        }
      } else {
        // Anpassung für WebAPI-Calls auf Unterseiten
        baseUrl = urlHref.slice(0, urlHref.lastIndexOf('/#'));
        // console.log('BaseUrl (slice): ' + baseUrl);
      }
      return baseUrl;
      // Für einen Test mit dem Developmentserver
      // return baseUrl.replace('4200', '8990');
    } else {
      // console.log('BaseUrl (environment): ' + environment.webAPIUrl);
      return this._baseUrl;
    }
  }

  get baseAPIUrl(): string {
    if (this._baseAPIUrl === null) {
      return this.baseUrl;
    } else {
      return this._baseAPIUrl;
    }
  }


}
